import React from "react";

import UpArrowIcon from "../../Layout/Icons/UpArrowIcon";

const UploadButton = ({ onShowUploadModal }) => {
  return (
    <button className="button button--round" onClick={onShowUploadModal}>
      Upload Photo/Full Color Art
      <UpArrowIcon />
    </button>
  );
};

export default UploadButton;
